import React, { useState } from 'react';
import { Collapse } from '../student/activity/ScoreReadout';
import { EM_DASH } from '../../lib/format';

const REASONS = {
  overdue_silent: 'Overdue and quiet',
  never_planned: 'Never made a plan',
  stopped: 'Stopped',
};

const reasonWords = (codes) => (codes || []).map((code) => REASONS[code]).filter(Boolean);

/**
 * Chat counts for the scope. Loaded beside the rest of Overview, with its
 * own loading and error. Zeros are a result, not an empty state.
 */
const OverviewChatCard = ({ state, onOpenStudent }) => {
  const [open, setOpen] = useState(false);
  const panelId = 'td-chat-attention';
  if (!state) return null;
  if (state.status === 'loading') return <p className="td-loading" role="status">Loading chat…</p>;
  if (state.status === 'error') {
    return (
      <div className="td-card" role="alert">
        <p>{state.error || 'Could not load chat.'}</p>
        <button type="button" className="td-btn td-btn--small" onClick={state.retry}>Retry</button>
      </div>
    );
  }
  const data = state.data || {};
  const median = data.median_messages == null ? EM_DASH : String(data.median_messages);
  const done = data.done_on_time || { done: 0, total: 0 };
  const people = data.needs_attention || [];
  return (
    <section className="td-card td-act-gap" aria-label="Chat">
      <h3 className="td-card__title">Chat</h3>
      <p className="td-act-meta">Counts for this group. Open a student to read their conversations.</p>
      <div className="td-act-statrow">
        <div className="td-stat">
          <span className="td-stat__eyebrow">Students using chat</span>
          <span className="td-stat__value">{data.students_using_chat ?? 0}</span>
        </div>
        <div className="td-stat">
          <span className="td-stat__eyebrow">Median messages</span>
          <span className="td-stat__value">{median}</span>
        </div>
        <div className="td-stat">
          <span className="td-stat__eyebrow">Active plans</span>
          <span className="td-stat__value">{data.students_with_active_plan ?? 0}</span>
        </div>
        <div className="td-stat">
          <span className="td-stat__eyebrow">Done on time</span>
          <span className="td-stat__value">{`${done.done} of ${done.total}`}</span>
        </div>
        <div className="td-stat">
          <span className="td-stat__eyebrow">Stopped</span>
          <span className="td-stat__value">{data.stopped ?? 0}</span>
        </div>
      </div>
      <Collapse
        id={panelId}
        open={open}
        onToggle={() => setOpen((value) => !value)}
        label="Details"
      >
        {people.length ? (
          <ul>
            {people.map((person) => (
              <li key={person.id}>
                <button type="button" className="td-btn td-btn--ghost" onClick={() => onOpenStudent(person.id)}>
                  {person.name}
                </button>
                <span className="td-act-meta">{reasonWords(person.reasons).join(' · ')}</span>
              </li>
            ))}
          </ul>
        ) : <p className="td-act-meta">Nobody in this list needs attention.</p>}
      </Collapse>
    </section>
  );
};

export default OverviewChatCard;
